import { combineReducers } from 'redux';
import { combineActions, handleAction } from 'redux-actions';
import {
  AnyObject,
  RootState,
  TargetByIdReducerPayload,
  TargetListsReducerPayload,
  TargetListsState,
  TargetPageKey,
  TargetsState
} from '../../../types';
import targetsActions from './actions';

const byIdReducer = handleAction<AnyObject, TargetByIdReducerPayload>(
  combineActions(
    targetsActions.fetchTargetSuccess,
    targetsActions.fetchTargetPageSuccess
  ).toString(),
  (state, action) => ({
    ...state,
    [action.payload.id]: {
      ...state[action.payload.id],
      [action.payload?.loadType ?? 'main']: action.payload.data
    }
  }),
  {}
);

const listsReducer = handleAction<TargetListsState, TargetListsReducerPayload>(
  targetsActions.fetchTargetsSuccess.toString(),
  (state, action) => {
    const { list, ...restPageData } = action.payload.pageData;
    const { page, ...restParams } = action.payload.params;
    return {
      byPage: {
        ...state.byPage,
        [page]: { list, ...restParams }
      },
      pageData: restPageData
    };
  },
  { pageData: null, byPage: {} }
);

export default combineReducers<TargetsState>({
  byId: byIdReducer,
  lists: listsReducer
});

export const getTargetsHomePageInfo = (state: RootState) =>
  state.app.targets.lists.pageData;
export const getTargetsHomePageList = (page: TargetPageKey) => (
  state: RootState
) => state.app.targets.lists.byPage[page];
export const getTargetPageData = (id: string, pageName: string) => (
  state: RootState
) => {
  const { [pageName]: pageData } = state.app.targets.byId[id] || {};
  return pageData;
};
export const getMainTargetPageData = (id: string) =>
  getTargetPageData(id, 'main');
